webpackJsonp([127938634361352],{

/***/ 867:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/A4Lieu_gauche_1_sphere.4805fa26.jpg";

/***/ }),

/***/ 67:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(3);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _boutonCollectif = __webpack_require__(19);
	
	var _boutonCollectif2 = _interopRequireDefault(_boutonCollectif);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  return _react2.default.createElement(
	    _gatsbyLink2.default,
	    { to: '/collectif-musical-orchestre-d-hommes-orchestres/', className: 'etiquette' },
	    _react2.default.createElement(_boutonCollectif2.default, null),
	    _react2.default.createElement(
	      'span',
	      null,
	      'Orchestre d\'hommes-orchestres'
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 328:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(3);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactHelmet = __webpack_require__(11);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _flexContainer = __webpack_require__(8);
	
	var _flexContainer2 = _interopRequireDefault(_flexContainer);
	
	var _sidebarLeft = __webpack_require__(12);
	
	var _sidebarLeft2 = _interopRequireDefault(_sidebarLeft);
	
	var _sidebarRight = __webpack_require__(13);
	
	var _sidebarRight2 = _interopRequireDefault(_sidebarRight);
	
	var _container = __webpack_require__(6);
	
	var _container2 = _interopRequireDefault(_container);
	
	var _titreAxe = __webpack_require__(14);
	
	var _titreAxe2 = _interopRequireDefault(_titreAxe);
	
	var _lieu = __webpack_require__(63);
	
	var _lieu2 = _interopRequireDefault(_lieu);
	
	var _btnMarieSavonnieresDeLaTroche = __webpack_require__(100);
	
	var _btnMarieSavonnieresDeLaTroche2 = _interopRequireDefault(_btnMarieSavonnieresDeLaTroche);
	
	var _btnLouisFortier = __webpack_require__(98);
	
	var _btnLouisFortier2 = _interopRequireDefault(_btnLouisFortier);
	
	var _btnCapsuleOdho = __webpack_require__(86);
	
	var _btnCapsuleOdho2 = _interopRequireDefault(_btnCapsuleOdho);
	
	var _btnOho = __webpack_require__(67);
	
	var _btnOho2 = _interopRequireDefault(_btnOho);
	
	var _info = __webpack_require__(7);
	
	var _info2 = _interopRequireDefault(_info);
	
	var _A4Lieu_gauche_1_sphere = __webpack_require__(867);
	
	var _A4Lieu_gauche_1_sphere2 = _interopRequireDefault(_A4Lieu_gauche_1_sphere);
	
	var _indexModule = __webpack_require__(16);
	
	var _indexModule2 = _interopRequireDefault(_indexModule);
	
	var _imageFooterAxe = __webpack_require__(111);
	
	var _imageFooterAxe2 = _interopRequireDefault(_imageFooterAxe);
	
	var _fragAxe = __webpack_require__(106);
	
	var _fragAxe2 = _interopRequireDefault(_fragAxe);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SecondPage = function SecondPage() {
	    return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	            _flexContainer2.default,
	            null,
	            _react2.default.createElement(_reactHelmet2.default, { bodyAttributes: { class: 'visions' } }),
	            _react2.default.createElement(
	                _sidebarLeft2.default,
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { style: { width: "100%", display: "flex", flexDirection: "column", justifyContent: "space-between", alignItems: "flex-end", paddingBottom: "1.45rem" } },
	                    _react2.default.createElement(
	                        'div',
	                        { style: { maxWidth: "520px", width: "70%", height: "auto", alignSelf: "center" } },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'metadata--wrapper' },
	                            _react2.default.createElement('img', { src: _A4Lieu_gauche_1_sphere2.default, alt: '' }),
	                            _react2.default.createElement(
	                                _info2.default,
	                                null,
	                                'La sph\xE8re \xE0 bout de bras (artiste \xE0 retracer). Photographe inconnu, Archives de l\'Il\xF4t Fleurie, ca2003.'
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                _container2.default,
	                null,
	                _react2.default.createElement(
	                    _titreAxe2.default,
	                    null,
	                    'Visions'
	                ),
	                _react2.default.createElement(_lieu2.default, null),
	                _react2.default.createElement(
	                    'h1',
	                    null,
	                    'Il\xF4t Fleurie'
	                ),
	                _react2.default.createElement(
	                    'p',
	                    null,
	                    'Initialement situ\xE9 dans l\u2019axe des rues Fleurie et De la Chapelle, l\'\xCElot Fleurie est une installation horticole et artistique qui prend forme \xE0 l\u2019\xE9t\xE9 1991. N\xE9e d\u2019une initiative citoyenne en r\xE9action \xE0 la d\xE9gradation d\u2019un terrain vague au coeur du quartier Saint-Roch, l\'\xCElot Fleurie gagne en appuis citoyens et devient un lieu mixte. Pour les r\xE9sidents du quartier et les passants, il sert de jardin communautaire, de place publique et d\u2019espace de rassemblement; pour les artistes qui s\'y retrouvent, il est \xE0 la fois un lieu de cr\xE9ation, de rencontre et de diffusion. Forc\xE9 de d\xE9m\xE9nager sous les bretelles de l\u2019autoroute Dufferin-Montmorency en 1998, l\u2019\xCElot devient, lors du Sommet des Am\xE9riques en 2001, un important lieu de rassemblement pour les militants.'
	                ),
	                _react2.default.createElement(_fragAxe2.default, null)
	            ),
	            _react2.default.createElement(
	                _sidebarRight2.default,
	                null,
	                _react2.default.createElement(_btnCapsuleOdho2.default, null),
	                _react2.default.createElement(_btnMarieSavonnieresDeLaTroche2.default, null),
	                _react2.default.createElement(_btnLouisFortier2.default, null),
	                _react2.default.createElement(_btnOho2.default, null)
	            )
	        ),
	        _react2.default.createElement(_imageFooterAxe2.default, null)
	    );
	};
	
	exports.default = SecondPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-l-ilot-fleurie-js-bee0e352622993911eb5.js